// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/shortcuts/shortcut-row.tsx
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/shortcuts/src/shortcut-row.tsx
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo field-check-app
//     node fleet/fleet.ts check --repo field-check-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { For, Show } from "solid-js";

interface ShortcutRowProps {
  desc: string;
  keys: string[];
}

export function ShortcutRow(props: ShortcutRowProps) {
  return (
    <div class="flex items-center justify-between py-1 px-1 rounded-lg hover:bg-muted/5 transition-colors">
      <span class="text-xs text-muted-foreground font-medium">{props.desc}</span>
      <div class="flex items-center gap-1 shrink-0">
        <For each={props.keys}>
          {(key, idx) => (
            <>
              <Show when={idx() > 0}>
                <span class="text-[10px] text-muted-foreground/40 font-bold px-0.5">+</span>
              </Show>
              <kbd class="h-5.5 min-w-[22px] inline-flex items-center justify-center rounded border border-border/60 bg-background px-1.5 font-mono text-[10px] font-bold text-foreground/80 shadow-sm">
                {key}
              </kbd>
            </>
          )}
        </For>
      </div>
    </div>
  );
}
